import {useContext} from 'react';
import {CarecoApiContext} from '@/app-context/careco-api-context';
import {useRosterStore} from '@/store/roster_store';
import {MixpanelEventType, MixpanelSSOLaunchEvent, SSOApplication, SSOLaunchMethod} from "@/api/dto/mixpanel";
import {log} from "@/helpers/logger";
import {useMixpanel} from "@/hooks/useMixpanel";

export function useOpenBeds() {
  const { carecoApi } = useContext(CarecoApiContext);
  const { currentRoster } = useRosterStore();
  const {mixpanelEventProperties} = useMixpanel();

  const openOpenBeds = async (applicationName: SSOApplication, launchMethod: SSOLaunchMethod) => {
    const newTab = window.open();
    if (!newTab) {
      return;
    }

    newTab.document.write('Loading...');

    try {
      const htmlContent = await carecoApi?.redirectToOpenBedsSSO(currentRoster?.id);
      if (htmlContent) {
        newTab.document.open();
        newTab.document.write(htmlContent);
        newTab.document.close();

        const event : MixpanelSSOLaunchEvent = {
          eventName: MixpanelEventType.BIH_SSO_LAUNCHED,
          ...mixpanelEventProperties!,
          applicationName,
          launchMethod
        };
        carecoApi?.postMixpanelEvent(event);
      }
    } catch (error) {
      log('error', 'Error fetching OpenBeds SSO Redirect:', error);
      newTab.document.open();
      newTab.document.write('Error loading content.');
      newTab.document.close();
    }
  };

  return {
    openOpenBeds,
  };
}
